import { Chart, ChartOption } from './Chart';
import { Box } from '@mui/material';

type HistoryData = {
  order: number;
  value: number;
};

type DataProps = {
  backgroundStyle?: boolean;
  lineColor?: string;
  pointColor?: string;
  title?: string;
  data: {
    name: string;
    history: HistoryData[];
  };
};

const LineChartTermometro: React.FC<DataProps> = ({ 
  backgroundStyle = false, 
  lineColor, 
  pointColor, 
  title, 
  data 
}) => {
  const months = Array.from({ length: 12 }, (_, i) => new Date(0, i).toLocaleString('default', { month: 'short' }));
  const values = data.history.map(h => h.value);

  const option = {
    title: {
      text: title || `Histórico de score frequência do aluno: ${data.name}`,
      textStyle: {
        fontSize: '14px',
      },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985',
        },
      },
      formatter: function (params: any) {
        const value = params[0]?.data;
        return `${params[0]?.name}: ${value}`;
      },
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: months,
      axisLabel: {
       
      },
    },
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          formatter: '{value}', 
          margin: 30,
        },
      },
    ],
    series: [
      {
        name: 'Ano x Score geral',
        type: 'line',
        smooth: true,
        label: {
          show: true,
          position: 'top',
          color: pointColor || '#000',
          formatter: '{c}',
        },
        symbol: 'circle',
        symbolSize: 14,
        areaStyle: {
          color: backgroundStyle ? 'rgba(252, 159, 159, 0.6)' : 'transparent',
        },
        lineStyle: {
          color: lineColor || '#FC9F9F',
          width: 4,
        },
        itemStyle: {
          borderWidth: 1,
          color: lineColor || '#FC9F9F',
        },
        emphasis: {
          focus: 'series',
        },
        data: values,
      },
    ],
  } as ChartOption;

  return (
    <Box sx={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }} height={'400px'}>
      <Chart option={option} />
    </Box>
  );
};

export default LineChartTermometro;
